module.exports = __webpack_public_path__ + "img/img_shou@2x.d2e9691d.png";